import React from "react";

const SvgComponent = props => (
  <svg width={43.243} height={34.461} viewBox="0 0 43.243 34.461" {...props}>
    <g fill="#83a5b3">
      <path d="M32.375 13.823c1.451-.588 2.902-.541 3.318-.541 2.081 0 4.598 1.82 4.598 4.81a4.6 4.6 0 0 1-4.598 4.598h-.207a1.406 1.406 0 0 0 0 2.812h.201a7.554 7.554 0 0 0 7.555-7.555s.039-7.546-7.902-7.546c-1.717-7.069-8.332-7.428-10.188-6.929C23.14 1.47 19.79 0 16.403 0 9.687 0 4.185 5.192 3.688 11.783a7.349 7.349 0 0 0 3.661 13.72h.999c.637 0 1.234-.688 1.234-1.406 0-.776-.629-1.406-1.406-1.406h-.19c-2.744 0-4.77-1.986-4.77-4.557 0-2.099 1.333-3.94 3.417-4.568.247-9.922 8.962-10.429 9.93-10.429 2.878 0 5.734 1.413 7.572 3.503 3.717-1.222 8.811 1.643 8.24 7.183z" />
      <path d="M16.153 23.374a1.494 1.494 0 0 0-2.585-1.494l-1.658 2.873a1.493 1.493 0 0 0 2.587 1.494l1.656-2.873zM23.893 23.374a1.492 1.492 0 1 0-2.586-1.494l-1.658 2.873a1.493 1.493 0 0 0 2.586 1.494l1.658-2.873zM17.042 30.842a1.491 1.491 0 0 0-.546-2.038 1.495 1.495 0 0 0-2.04.546l-1.657 2.872a1.492 1.492 0 1 0 2.586 1.493l1.657-2.873zM31.631 23.374a1.495 1.495 0 0 0-2.588-1.494l-1.658 2.873a1.494 1.494 0 0 0 2.587 1.494l1.659-2.873zM24.78 30.842a1.493 1.493 0 0 0-2.586-1.492l-1.658 2.872a1.493 1.493 0 1 0 2.586 1.493l1.658-2.873z" />
    </g>
  </svg>
);

export default __webpack_public_path__ + "static/media/09d.d83471c2.svg";
export { SvgComponent as ReactComponent };



// WEBPACK FOOTER //
// ./src/assets/weather-icons/09d.svg